<div class="converter-iframe-container">
  <iframe [src]="iframeUrl | safeUrl" width="100%" height="100%"></iframe>
</div>